// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"1543e661","160":"fd3d5f60","641":"99fc9f39","820":"e9268408","875":"c9cb5106"}[chunkId] + ".chunk.js";
};